import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { authRoutes } from "./authRoutes";
import { mainRoutes } from "./mainRoutes";
import { adminRoutes } from "./adminRoutes";
import { activatedRoutes } from "./activatedRoutes";
import { miscRoutes } from "./miscRoutes";
import LoadingContainer from "@shared/ui/LoadingContainer/LoadingContainer";

const NotFound = lazy(() => import("@pages/not-found/NotFound"));

const router = createBrowserRouter([
  {
    errorElement: <NotFound />,
    children: [
      ...miscRoutes,
      authRoutes,
      mainRoutes,
      adminRoutes,
      ...activatedRoutes,
    ],
  },
]);

export default function AppRouter() {
  return (
    <Suspense fallback={<LoadingContainer height="100vh" />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
